import { render, staticRenderFns } from "./MultiDocumentTable.vue?vue&type=template&id=1276a6d5&scoped=true"
import script from "./MultiDocumentTable.vue?vue&type=script&lang=js"
export * from "./MultiDocumentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276a6d5",
  null
  
)

export default component.exports